export enum PaginatorMessage {
  BUTTON_FIRST_PAGE = 'First page',
  BUTTON_NEXT_PAGE = 'Next page',
  BUTTON_PREVIOUS_PAGE = 'Previous page',
  BUTTON_LAST_PAGE = 'Last page',
}

export const DEFAULT_PAGE_SIZE_OPTIONS = [100, 200, 500];
